(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.cream-navigation').forEach((header) => {
      if (header.dataset.navigationReady) return;
      header.dataset.navigationReady = 'true';
      const controller = new AbortController();
      const listen = (node, type, handler) => node?.addEventListener(type, handler, { signal: controller.signal });
      const groups = [...header.querySelectorAll('.main-nav > .nav-dropdown')];
      const finePointer = matchMedia('(min-width:981px) and (hover:hover) and (pointer:fine)');
      const timers = new Map();
      let keyboard = false;
      let restoringFocus = false;
      const clear = (group) => { clearTimeout(timers.get(group)); timers.delete(group); };
      const setOpen = (group, open) => {
        clear(group);
        group.open = open;
        group.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
        if (open) groups.forEach(other => { if (other !== group) setOpen(other, false); });
      };
      groups.forEach((group, index) => {
        const summary = group.querySelector(':scope > summary');
        const panel = group.querySelector(':scope > .nav-panel');
        if (!summary || !panel) return;
        const scope = header.closest('[id]')?.id || 'SibrilleHeader';
        panel.id = panel.id || `${scope}-NavigationPanel-${index}`;
        summary.setAttribute('aria-controls', panel.id);
        summary.setAttribute('aria-expanded', String(group.open));
        listen(group, 'toggle', () => {
          summary.setAttribute('aria-expanded', String(group.open));
          if (group.open) groups.forEach(other => { if (other !== group && other.open) setOpen(other, false); });
        });
        listen(group, 'pointerenter', (event) => {
          if (!finePointer.matches || event.pointerType === 'touch') return;
          clear(group);
          timers.set(group, setTimeout(() => setOpen(group, true), 80));
        });
        listen(group, 'pointerleave', (event) => {
          if (!finePointer.matches || event.pointerType === 'touch') return;
          clear(group);
          timers.set(group, setTimeout(() => {
            if (!group.contains(document.activeElement)) setOpen(group, false);
          }, 160));
        });
        listen(group, 'focusin', () => {
          clear(group);
          if (keyboard && !restoringFocus) setOpen(group, true);
        });
        listen(group, 'focusout', (event) => {
          if (event.relatedTarget && !group.contains(event.relatedTarget)) setOpen(group, false);
        });
        listen(summary, 'keydown', (event) => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          setOpen(group, true);
          panel.querySelector('a[href],button')?.focus();
        });
      });
      listen(document, 'keydown', (event) => { if (event.key === 'Tab') keyboard = true; });
      listen(document, 'pointerdown', () => { keyboard = false; });
      listen(document, 'keydown', (event) => {
        if (event.key !== 'Escape' || document.querySelector('dialog[open]')) return;
        const group = groups.find(item => item.open);
        if (group?.open) {
          restoringFocus = true;
          setOpen(group, false);
          group.querySelector('summary')?.focus();
          queueMicrotask(() => { restoringFocus = false; });
          event.preventDefault();
          event.stopPropagation();
        }
      });
      listen(document, 'click', (event) => {
        if (!header.contains(event.target)) groups.forEach(group => setOpen(group, false));
      });
      listen(header, 'focusout', (event) => {
        if (event.relatedTarget && !header.contains(event.relatedTarget)) groups.forEach(group => setOpen(group, false));
      });
      listen(finePointer, 'change', () => groups.forEach(group => setOpen(group, false)));
      const mobile = document.getElementById('MobileMenu');
      mobile?.querySelectorAll('[data-mobile-nav-group]').forEach((group) => {
        listen(group, 'toggle', () => {
          if (group.open) mobile.querySelectorAll('[data-mobile-nav-group]').forEach((other) => { if (other !== group) other.open = false; });
        });
      });
      listen(mobile, 'click', (event) => { if (event.target.closest('a[href]')) mobile.close(); });
      listen(document, 'shopify:section:unload', (event) => {
        if (!event.target.contains(header)) return;
        timers.forEach(timer => clearTimeout(timer));
        controller.abort();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
